import { ToolWheelHost } from '@edge/charts'
import { useChartPreferences } from './chart-preferences-store'

/**
 * The app's one drawing tool wheel (hold Tab over a chart). Mounted once in
 * AppLayout; every chart surface with drawing tools registers itself with the
 * wheel, so nothing is wired per chart. The layout is one global record on the
 * user's chart preferences, shared by every page.
 */
export function ChartToolWheelHost() {
  const { toolWheelSlots, setToolWheelSlots } = useChartPreferences()
  return <ToolWheelHost slots={toolWheelSlots} onSlotsChange={setToolWheelSlots} />
}
